import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { Rocket } from "lucide-react";

/** Scarcity banner. `refreshTick` bumps trigger an immediate refetch so
 *  the counter updates instantly after a successful claim. */
export default function PromoBanner({ refreshTick = 0 }) {
  const [promo, setPromo] = useState(null);

  useEffect(() => {
    let alive = true;
    const tick = () => http.get("/promo/status").then(({ data }) => {
      if (alive) setPromo(data);
    }).catch(() => {});
    tick();
    const iv = setInterval(tick, 15000);
    return () => { alive = false; clearInterval(iv); };
  }, [refreshTick]);

  if (!promo || !promo.is_free_phase) return null;

  return (
    <div data-testid="promo-banner" className="promo-banner">
      <div className="relative max-w-6xl mx-auto px-4 py-2 flex items-center gap-3 text-sm justify-center flex-wrap">
        <Rocket className="w-4 h-4 text-cyan-300" />
        <span className="font-semibold tracking-wide">
          LAUNCH PROMO: The first {promo.total} blocks are 100% FREE!
        </span>
        <span className="font-mono text-cyan-300" data-testid="promo-count">
          {promo.used}/{promo.total} claimed
        </span>
        <span className="text-[var(--fg-muted)]">— grab yours before time runs out!</span>
        <div className="absolute inset-0 shimmer pointer-events-none opacity-40" />
      </div>
    </div>
  );
}
